import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormControlInit, DwFormFieldConfig, DwMetaDataService, DwMetaDataServiceToken } from '@devwareapps/devware-cap';
import { DateTimeUtilService } from '../../util/date-time-util.service';

@DwComponent({
  key: 'fitness-email-display',
  name: 'E-mail Display',
  componentType: DwComponentType.formControl,
  isGlobal: true
})

@Component({
  selector: 'app-email-display',
  template: `
  <div class="read-only">
    <a href="mailto:{{email}}" *ngIf='email'>{{email}}</a>
    <ng-container *ngIf="!email">{{missingTextData}}</ng-container>
  </div>
`
})
export class EmailDisplayComponent implements DwFormControl, DwFormControlInit, OnDestroy {
  fieldDef: DwFormFieldConfig;
  formGroup: FormGroup;
  context: DwContext;
  useDisplayField?: boolean;

  email?: string;
  missingTextData: string;
  subscription: any;

  constructor(@Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dateTimeUtilService: DateTimeUtilService
  ) { }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  initControl(): void {
    this.email = this.control.value;

    this.missingTextData = this.fieldDef.readOnlyMissingDataText || 'None';

    this.subscription = this.control.valueChanges.subscribe((value) => {
      this.email = value;
    });
  }

  get control(): AbstractControl {
    return this.formGroup.get(this.fieldDef.attrName);
  }
}
